export const URL_SYSTEM_IDENTIFIER = "fortnox";
